import { useQuery } from "@tanstack/react-query";
import axios, { AxiosError } from "axios";
import { usePermissionModal } from "../contexts/PermissionModalContext";

export interface OperadorIndicador {
  usuarioId: string;
  nome: string;
  quantidadeVendas: number;
  quantidadeCancelamentos: number;
  taxaCancelamento: number;
}

export interface IndicadoresOperacaoResponse {
  operadores: OperadorIndicador[];
}

const fetchIndicadoresOperacao = async (): Promise<IndicadoresOperacaoResponse> => {
  const response = await axios.get<IndicadoresOperacaoResponse>(
    "/api/dashboard/financeiro/indicadores-operacao"
  );
  return response.data;
};

export const useIndicadoresOperacao = () => {
  const { getQueryRetryHandler } = usePermissionModal();

  return useQuery<IndicadoresOperacaoResponse, AxiosError>({
    queryKey: ["dashboardFinanceiro", "indicadoresOperacao"],
    queryFn: fetchIndicadoresOperacao,
    retry: getQueryRetryHandler({
      queryKey: ["dashboardFinanceiro", "indicadoresOperacao"],
      defaultMessage:
        "Você não possui permissão para visualizar os indicadores de operação.",
      showModal: false,
    }),
  });
};
